// extracted by mini-css-extract-plugin
export default {"noShrink":"Highscore_noShrink__KMaBI","button":"Highscore_button__z+dEC"};